module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-main main-container"
  }, [_c('page-header'), _vm._v(" "), _c('about-content'), _vm._v(" "), _c('div', {
    staticClass: "w3-container about-container"
  }, [_c('h1', {
    staticClass: "w3-xxxlarge"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('News')))])]), _vm._v(" "), _c('hr', {
    staticClass: "w3-round"
  }), _vm._v(" "), _vm._l((_vm.news.slice(0, 3)), function(article, index) {
    return _c('news-article', {
      key: article._id,
      attrs: {
        "article": article,
        "no-separator": index === _vm.news.slice(0, 3).length - 1
      }
    })
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/hireink'
    }
  }, [_c('button', {
    staticClass: "w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('More News')) + "\n      ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "w3-container about-container",
    attrs: {
      "id": "termekeink"
    }
  }, [_c('h1', {
    staticClass: "w3-xxxlarge"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('Our products')))])]), _vm._v(" "), _c('hr', {
    staticClass: "w3-round"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Products text')))]), _vm._v(" "), _c('div', {
    staticClass: "items-images-container"
  }, _vm._l((_vm.itemCategories), function(itemCategory) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": ("/termekeink/" + (itemCategory._id))
      }
    }, [_c('div', {
      staticClass: "item-category-name-layer"
    }, [_c('h2', [_vm._v(_vm._s(itemCategory.name[_vm.locale]))])]), _vm._v(" "), _c('img', {
      attrs: {
        "src": ("static/images/item_categories/" + (itemCategory.image))
      }
    })])], 1)
  }), 0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/termekeink"
    }
  }, [_c('button', {
    staticClass: "w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('More products')) + "\n      ")])])], 1), _vm._v(" "), _c('contact-content')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f337af28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 955
// module chunks = 0